/**
 * Created by jmulder on 27/07/17.
 */

export function sleepMilliseconds(milliseconds) {
  var start = new Date().getTime();
  //console.log(start);
  for (var i = 0; i < 1e20; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      //console.log("- " + new Date().getTime());
      break;
    }
  }
}
